import * as React from 'react';
import { Nav, INavStyles, INavLinkGroup, INavLink } from '@fluentui/react/lib/Nav';
import '../../css/layout/leftMenu.scss';
import { LeftMenuContext } from '../../context/leftMenu.context';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import useToken from '../../components/account/login/useToken';
export const urlMapingKey = {
  Matrix: '/matrix',
  Product: '/products',
  Tests: '/tests',
  Products: '/settings/products',
  Components: '/settings/components',
  Modules: '/settings/modules',
  Vendors: '/settings/vendors',
  Users: '/settings/users',
  Configurations: '/settings/configurations',
} as any;
const LeftMenu: React.FunctionComponent = () => {
  const { isShow, setSelectedMenuItem, selectedMenuItem } = React.useContext(LeftMenuContext);
  const { t } = useTranslation();
  const { userTokenInfo } = useToken();
  let routerHistory = useHistory();
  const [isExpanded, setisExpanded] = React.useState(true);

  let navLinkGroups: INavLinkGroup[] = [
    {
      links: [
        {
          name: t('Matrix'),
          url: '',
          key: 'Matrix',
          onClick: () => {
            setSelectedMenuItem('Matrix');
            routerHistory.push(urlMapingKey['Matrix']);
          },
        },
        {
          name: t('Products'),
          url: '',
          key: 'Product',
          onClick: () => {
            routerHistory.push(urlMapingKey['Product']);
            setSelectedMenuItem('Product');
          },
        },
        {
          name: t('Tests'),
          url: '',
          key: 'Tests',
          onClick: () => {
            routerHistory.push(urlMapingKey['Tests']);
            setSelectedMenuItem('Tests');
          },
        },
        {
          name: t('Settings'),
          key: 'Settings',
          url: '',
          expandAriaLabel: 'Expand Home section',
          collapseAriaLabel: 'Collapse Home section',
          isExpanded: isExpanded,
          onClick: () => {
            setisExpanded(!isExpanded);
          },
          links: [
            {
              name: t('Products'),
              url: '',
              key: 'Products',
              onClick: () => {
                setSelectedMenuItem('Products');
                routerHistory.push(urlMapingKey['Products']);
              },
            },
            {
              name: t('Components'),
              url: '',
              key: 'Components',
              onClick: () => {
                setSelectedMenuItem('Components');
                routerHistory.push(urlMapingKey['Components']);
              },
            },
            {
              name: t('Modules'),
              url: '',
              key: 'Modules',
              onClick: () => {
                setSelectedMenuItem('Modules');
                routerHistory.push(urlMapingKey['Modules']);
              },
            },
            {
              name: t('Vendors'),
              url: '',
              key: 'Vendors',
              onClick: () => {
                setSelectedMenuItem('Vendors');
                routerHistory.push(urlMapingKey['Vendors']);
              },
            },
            {
              name: t('Users'),
              url: '',
              key: 'Users',
              onClick: () => {
                setSelectedMenuItem('Users');
                routerHistory.push(urlMapingKey['Users']);
              },
            },
            {
              name: t('Configurations'),
              url: '',
              key: 'Configurations',
              onClick: () => {
                setSelectedMenuItem('Configurations');
                routerHistory.push(urlMapingKey['Configurations']);
              },
            },
          ],
        },
      ],
    },
  ];
  if (userTokenInfo) {
    switch (userTokenInfo['Role'].toString().toLocaleUpperCase()) {
      case 'SALLINGGROUP':
        let settingMenu = navLinkGroups[0].links.find((o) => o.key == 'Settings');
        if (settingMenu) {
          settingMenu.links = settingMenu.links?.filter((o) => o.key != 'Configurations' && o.key != 'Users');
        }
        break;
      case 'ADMINISTRATOR':
        break;
      default:
        let settingMenu1 = navLinkGroups[0].links.find((o) => o.key == 'Settings');
        if (settingMenu1) {
          settingMenu1.links = settingMenu1.links?.filter((o) => o.key == 'Components');
        }
        break;
    }
  }
  const _onRenderLink = (
    item?: INavLink,
    defaultRenderer?: (link?: INavLink) => JSX.Element | null,
  ): JSX.Element | null => {
    if (!item || !defaultRenderer) {
      return null;
    }
    let url = '';
    if (item.key) {
      url = urlMapingKey[item.key];
    }
    return (
      <>
        {defaultRenderer({ ...item })}
        {/* {(url) && (<Link className="link-component" to={url}></Link>)} */}
      </>
    );
  };
  return (
    <>
      {isShow && (
        <div className={'leftMenu'}>
          <Nav selectedKey={selectedMenuItem} groups={navLinkGroups} onRenderLink={_onRenderLink} />
        </div>
      )}
    </>
  );
};
export default LeftMenu;
